import styled, { css } from 'styled-components';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Button, ClickAnchor } from 'components/core';

const UserAvatar = styled(AccountCircleIcon)`
  color: var(--color-gothic);
  font-size: 50px;
`;

const RemoveLink = styled(ClickAnchor)<{ $disabled?: boolean }>`
  color: var(--color-grey1);
  font-size: 15px;
  font-weight: 600;

  ${({ $disabled }) =>
    $disabled
      ? css`
          color: var(--color-grey3);
          cursor: not-allowed;
          opacity: 0.5;
          pointer-events: none;
        `
      : css`
          &:hover {
            color: var(--color-stromboli);
          }
        `}
`;

const CancelKycLink = styled(ClickAnchor)`
  color: var(--color-grey1);
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;

  &:hover {
    color: var(--color-stromboli);
  }
`;

const modalButtonPadding = css`
  min-width: unset;
  min-height: unset;
  padding-left: 24px;
  padding-right: 24px;
`;

const ModalCancelButton = styled(Button)`
  ${modalButtonPadding}
`;

const ModalConfirmButton = styled(Button)`
  ${modalButtonPadding}

  &.MuiButton-contained {
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    text-shadow: none;
  }
`;

export const Styled = {
  UserAvatar,
  RemoveLink,
  CancelKycLink,
  ModalCancelButton,
  ModalConfirmButton,
};
